import { render, staticRenderFns } from "./modal-add-task.vue?vue&type=template&id=478aa9cd&"
import script from "./modal-add-task.vue?vue&type=script&lang=js&"
export * from "./modal-add-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports